import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '@/utils/analytics';
import { hasAnalyticsConsent } from '@/utils/consentState';

/**
 * Tracks page views on route change only when analytics consent is given.
 * Replaces Plausible enableAutoPageviews so we can stop tracking on consent revoke.
 */
const AnalyticsPageViewTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (hasAnalyticsConsent()) {
      trackPageview(window.location.href);
    }
  }, [pathname]);

  return null;
};

export default AnalyticsPageViewTracker;
